"use client"

import { Icon, type AnyIcon } from "./ui"
import { SITE } from "../lib/site"
import { useT } from "../lib/router"

const socialIconNames = new Set<AnyIcon>(["facebook", "linkedin", "instagram", "github"])

export function SocialLinks() {
  const t = useT()
  return (
    <nav className="mt-6" aria-label={t({ en: "Follow Orkest", ar: "تابع أوركست" })}>
      <ul className="flex flex-wrap items-center justify-start gap-3">
        {SITE.socials.map((profile) => (
          <li key={profile.id}>
            <a
              href={profile.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t({ en: `Orkest on ${profile.name} (opens in a new tab)`, ar: `أوركست على ${profile.name} (يفتح في تبويب جديد)` })}
              className="inline-flex size-11 items-center justify-center rounded-r8 border border-white/30 text-white transition-colors hover:border-white hover:bg-white/10"
            >
              {socialIconNames.has(profile.id as AnyIcon) && (
                <Icon name={profile.id as AnyIcon} className="size-5" />
              )}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  )
}
